import assert from 'shared/utils/assert'
import BackendAPIService from './BackendAPIService'

const API_VERSION = 'v2'

const config = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}

class AddressService extends BackendAPIService {
  constructor(props) {
    super(props)

    this.apiVersion = API_VERSION
  }

  addressRoot = () =>
    `/cacheable/addresses/${this.apiVersion}/${this.tenantPath}`

  getRootUrl(id) {
    if (id) {
      return `${this.addressRoot()}/${id}`
    }
    return `${this.addressRoot()}/`
  }

  getRootDoorDeliveryUrl() {
    return `${this.addressRoot()}/doorDelivery`
  }

  getRootPupDeliveryUrl() {
    return `${this.addressRoot()}/pickupStationDelivery`
  }

  async createAddress(payload) {
    assert(payload, 'AddressService.createAddress: please provide "payload"')
    const response = await this.post(this.getRootUrl(), payload, config)
    this.logger.debug('Address Service create address!', 'dataCreation')
    return response
  }

  async updateAddress(id, payload) {
    assert(id, 'AddressService.updateAddress: please provide "id"')
    assert(payload, 'AddressService.updateAddress: please provide "payload"')
    const response = await this.put(this.getRootUrl(id), payload, config)
    this.logger.debug(
      `Address Service update address id ${id} !`,
      'dataUpdating'
    )
    return response
  }

  async doorDelivery(ctx = null) {
    const response = await this.get(this.getRootDoorDeliveryUrl(), null, ctx)
    this.logger.debug(`Address Service get door delivery list!`, 'dataFetching')
    return response
  }

  async pickupStationDelivery() {
    const response = await this.get(this.getRootPupDeliveryUrl())
    this.logger.debug(
      `Address Service get pickupStationDelivery list!`,
      'dataFetching'
    )
    return response
  }
}

export default AddressService
